import _extends from "@babel/runtime/helpers/extends";
import '../../css-tokens';
import React, { forwardRef } from 'react';
import cx from 'classnames';
import { ChevronDown, Checkmark } from '@mediahuis/chameleon-theme-wl/icons';
import system from '../../system';
import Base from '../Base';
import Icon from '../Icon';
import Label from '../Label';
import Message from '../Message';
import Box from '../Box';
import styles from './index.module.css';
const SYSTEM_PROPS = ['marginProps'];
const Select = /*#__PURE__*/function () {
  const Select = /*#__PURE__*/forwardRef((_ref, ref) => {
    let {
      action,
      children,
      error,
      success,
      id,
      label,
      labelHidden,
      message,
      optionalLabel,
      disabled,
      required,
      onChange,
      placeholder,
      iconLeft,
      value,
      ...props
    } = _ref;
    const [className, style, rest] = system(props, SYSTEM_PROPS);
    const labelId = `${id}-label`;
    const messageId = `${id}-message`;
    return /*#__PURE__*/React.createElement(Base, {
      className: cx(styles.root, className),
      style: style
    }, /*#__PURE__*/React.createElement(Label, {
      action: action,
      alignItems: "baseline",
      as: "label",
      htmlFor: id,
      id: labelId,
      hidden: labelHidden,
      optional: optionalLabel,
      mb: !labelHidden ? 3 : 0
    }, label), /*#__PURE__*/React.createElement(Box, {
      position: "relative"
    }, /*#__PURE__*/React.createElement("select", _extends({
      "aria-describedby": message && messageId,
      "aria-labelledby": labelId,
      "aria-invalid": !!error,
      "aria-required": required ? 'true' : 'false',
      className: cx(styles.select, iconLeft && styles.selectIconLeft, error && styles.error, success && styles.success, value === '' && styles.placeholder),
      defaultValue: typeof value === 'undefined' ? '' : undefined,
      disabled: disabled,
      id: id,
      onChange: onChange,
      ref: ref,
      required: !optionalLabel || required,
      value: value
    }, rest), placeholder && /*#__PURE__*/React.createElement("option", {
      value: "",
      disabled: true
    }, placeholder), children), iconLeft && /*#__PURE__*/React.createElement(Icon, {
      as: iconLeft,
      size: "medium",
      className: cx(styles.icon, styles.iconLeft)
    }), !!success && /*#__PURE__*/React.createElement(Icon, {
      className: cx(styles.icon, styles.success__icon, value === '' && styles.placeholder),
      as: Checkmark,
      size: "medium"
    }), /*#__PURE__*/React.createElement(Icon, {
      className: cx(styles.icon, styles.chevron, value === '' && styles.placeholder),
      as: ChevronDown,
      size: "medium"
    })), message && /*#__PURE__*/React.createElement(Box, {
      pt: 2
    }, /*#__PURE__*/React.createElement(Message, {
      error: error,
      id: messageId
    }, message)));
  });
  Select.displayName = 'Select';
  Select.identifier = Select.displayName; // used in docs website
  Select.clonableProps = SYSTEM_PROPS;
  return Select;
}();
export default Select;